import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const contents_glass = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('glass_coverage')]:
        BaseSchema_ContentsV1GetsafeDe.shape.glass_coverage,
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_glass.title',
        },
        /**
         * TODO: we hardcoded the price for now
         * introduce back dynamic price for extension
         * when we are supporting interpollation value for inline translations
         * https://hellogetsafe.atlassian.net/browse/BFPC-662
         */
        // cms: {
        //   product: glassProductKey,
        //   value: 'roughMonthlyPremium',
        // },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('glass_coverage'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.extension.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.extension.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contentsNxt:steps.contents_glass.infoBox.text',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'contents_natural_disasters',
  }) as const satisfies AnyStepConfiguration

export default contents_glass
